import React from 'react';

interface AccordionProps {
  /** Titolo dell'accordion */
  title: string;
  /** Contenuto dell'accordion */
  children: React.ReactNode;
  /** Stato aperto/chiuso dell'accordion */
  isOpen: boolean;
  /** Funzione per alternare lo stato dell'accordion */
  onToggle: () => void;
  /** Classe CSS personalizzata per il container */
  className?: string;
  /** Classe CSS personalizzata per l'header */
  headerClassName?: string;
  /** Classe CSS personalizzata per il contenuto */
  contentClassName?: string;
}

/**
 * Componente Accordion riutilizzabile
 * Fornisce un'interfaccia standard per sezioni espandibili/richiudibili
 */
export const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
  className = '',
  headerClassName = '',
  contentClassName = ''
}) => {
  return (
    <div className={`accordion-container ${className}`}>
      <div 
        className={`filtri-header ${headerClassName}`} 
        onClick={onToggle}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={`accordion-content-${title.replace(/\s+/g, '-').toLowerCase()}`}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <h2>{title}</h2>
        <span className={`accordion-icon ${isOpen ? 'open' : ''}`}>
          ▼
        </span>
      </div>
      
      <div 
        className={`filtri-content ${isOpen ? 'open' : ''} ${contentClassName}`}
        id={`accordion-content-${title.replace(/\s+/g, '-').toLowerCase()}`}
        aria-hidden={!isOpen}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;